import { Theme } from "@mui/material/styles";
import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles((theme: Theme) => ({
  boxCentral:{
    height: '31.9rem', 
    width: '33.75rem', 
    padding: '1.5rem',
  },
  boxImg:{
    height: '230px', 
    width: '540px', 
    marginBottom: '16px'
  },
  boxButtons:{
    display: 'flex', 
    justifyContent: 'space-between'
  },
  titulo:{
    marginBottom: '16px !important',
    fontWeight: '600 !important',
    fontSize: '1.5rem !important',
    lineHeight:'1.828rem !important'
  },
  subTitulo:{
    marginBottom: '16px !important',
    fontWeight: '500 !important',
    fontSize: '1rem !important',
    lineHeight:'1.75rem !important',
    color: '#616161 !important'
  },
  buttonVoltar:{
    fontWeight: '500 !important',
    fontSize: '1rem !important',
    lineHeight:'1.21rem !important',
    color: 'black !important',
    border: '1px solid #B0B0B0 !important',
    padding: '0.75rem 1rem 0.75rem 1rem !important'
  }
}));